import { useState, Fragment } from "react";
import { withRouter, useHistory } from "react-router-dom";
import useStyles from "./styles";
import Avatar from "@material-ui/core/Avatar";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import VisibilityOutlined from "@material-ui/icons/Visibility";
import VisibilityOutlinedOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
    GoogleLoginButton,
    MicrosoftLoginButton,
} from "react-social-login-buttons";

const Login = ({ returnUrl, ...props }: any) => {
    var classes = useStyles();
    const history = useHistory();

    const [username, setUsername] = useState("");

    const [password, setPassword] = useState("");

    const [error, setError] = useState(false);

    const [passwordShown, setPasswordShown] = useState(false);

    const handleClickShowPassword = (event: any) => {
        event.preventDefault();
        setPasswordShown(passwordShown ? false : true);
    };

    const handleMouseDownPassword = (event: any) => {
        event.preventDefault();
    };

    const logMeIn = async (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        const response = await fetch(
            `/api/authenticate/login?ReturnUrl=${encodeURIComponent(
                returnUrl
            )}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    username,
                    password,
                    returnUrl,
                }),
            }
        );

        if (response.ok) {
            const data = await response.json();
            if (data && data.requireTwoFactor) {
                setUsername("");
                setPassword("");
                history.push(
                    `/login/2fa?ReturnUrl=${encodeURIComponent(
                        data.redirectUrl
                    )}`
                );
            } else if (data && data.isOk) {
                setUsername("");
                setPassword("");
                if (data.multiTenant) {
                    history.push(
                        `/login/brands?ReturnUrl=${encodeURIComponent(
                            data.redirectUrl
                        )}`
                    );
                } else {
                    window.location = data.redirectUrl;
                }
            } else if (data.isOk) {
                //alert(data);
                setError(true);
            }
        } else {
            //alert(await response.json())
            setError(true);
        }
    };

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Iniciar Sesión
            </Typography>
            <form className={classes.form} noValidate>
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    type="email"
                    autoFocus
                    onChange={(e) => {
                        setUsername(e.target.value);
                        setError(false);
                    }}
                    error={error}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Contraseña"
                    type={passwordShown ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setError(false);
                    }}
                    error={error}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {passwordShown ? (
                                        <VisibilityOutlined />
                                    ) : (
                                        <VisibilityOutlinedOff />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                {/* <FormControlLabel
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        /> */}
                {error && (
                    <InputLabel
                        style={{
                            color: "#f44336",
                            paddingTop: 20,
                            paddingBottom: 20,
                        }}
                    >
                        Usuario y/o contraseña incorrecto(s).
                    </InputLabel>
                )}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={(e: any) => logMeIn(e)}
                >
                    Ingresar
                </Button>
                <Grid container>
                    <Grid item md>
                        <GoogleLoginButton
                            onClick={() =>
                                props.history.push(
                                    `/login/external/google?ReturnUrl=${encodeURIComponent(
                                        returnUrl
                                    )}`
                                )
                            }
                        >
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                align="center"
                            >
                                <Link color="inherit">Google</Link>
                            </Typography>
                        </GoogleLoginButton>
                    </Grid>
                    {/* <Grid item md>
            <MicrosoftLoginButton
              onClick={() => props.history.push(`/login/microsoft?ReturnUrl=${encodeURIComponent(returnUrl)}`)}
            >
              <Typography variant="body2" color="textSecondary" align="center">
                <Link color="inherit">Microsoft</Link>
              </Typography>
            </MicrosoftLoginButton>
          </Grid> */}
                </Grid>
                <Grid
                    container
                    justify="center"
                    alignContent="center"
                    alignItems="center"
                    style={{ marginTop: 20, marginBottom: 20 }}
                >
                    <Grid item xs={12} md={3}>
                        <Link
                            href={`/login/forgot?ReturnUrl=${encodeURIComponent(
                                returnUrl
                            )}`}
                            variant="body2"
                        >
                            ¿Olvidaste tu contraseña?
                        </Link>
                    </Grid>
                </Grid>
            </form>
        </Fragment>
    );
};
export default withRouter(Login);
